<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      d="M5.2 19.88C6.66 27.52-5.73 7.9 12.88 7.1V3l8.64 6.73-8.64 6.49v-4.48s-9.14.5-7.68 8.14z"
      fill="currentColor"
    />
  </g>
</template>